import React from 'react';
import DatePicker from 'react-datepicker';
import { FormattedMessage } from 'react-intl';
import ReactTooltip from 'react-tooltip';

import { ConditionalRendering } from '@common-components/conditional-rendering';
import Spinner from '@common-components/spinner/Spinner';
import { CHART_CONST_INFO, REPORT_TYPE } from '@constants/common/chart/chartConst';
import BarChart from './BarChart';
import { StyledChartContainer } from './styles';

let tStatusRef: any = null;

interface IBarChartContainerProps {
    selectedReport: string;
    selectedDate: Date;
    onSelectedDate: (date: Date) => void;
    isDrillDownActive: boolean;
    backToDetailedReport: () => void;
    selectedWorkGropeName: string;
    chartData: any[];
    selectedChart: string;
    chartColors: string[];
    toUserChart: Function;
    serviceResponse: any[];
    legendClassName: string[];
    filterBasedOnLegend: (event: React.MouseEvent<HTMLAnchorElement>, item: string) => void;
    defaultReportCoolers: string[];
    isDrillDownAllowed: boolean;
    isLoading: boolean;
    title: string;
}

const BarChartContainer = ({
    selectedReport,
    selectedDate,
    onSelectedDate,
    isDrillDownActive,
    backToDetailedReport,
    selectedWorkGropeName,
    chartData,
    selectedChart,
    chartColors,
    toUserChart,
    serviceResponse,
    legendClassName,
    filterBasedOnLegend,
    defaultReportCoolers,
    isDrillDownAllowed,
    isLoading,
    title,
}: IBarChartContainerProps) => {
    const ChartTitle = () => (
        <>
            {selectedReport === REPORT_TYPE.UPCOMING_DUE_DATES ? (
                <h4 className="--chart_title ">
                    <div>
                        <strong id="selectedDate">{CHART_CONST_INFO.TITLE}</strong>
                        <DatePicker
                            id="effectiveDate"
                            dateFormat="MM/dd/yyyy"
                            selected={selectedDate}
                            onChange={onSelectedDate}
                            ariaLabelledBy="selectedDate"
                        />
                    </div>
                </h4>
            ) : (
                <h4 className="--chart_title">
                    <div>
                        <strong>{CHART_CONST_INFO.TITLE_RESOLVED_TODAY}</strong>
                    </div>
                </h4>
            )}
        </>
    );

    return (
        <div className="grid-row">
            <div className={`chartContainer ${selectedChart}`}>
                <div className="--charts_default">
                    <ChartTitle />
                    {isDrillDownActive && (
                        <div className="--sub-heading">
                            <span>
                                <a
                                    href="#"
                                    onClick={() => {
                                        backToDetailedReport();
                                    }}
                                >
                                    {CHART_CONST_INFO.BACK}
                                </a>
                            </span>
                            <span className="ml-2">
                                <strong>{selectedWorkGropeName}</strong>
                            </span>
                        </div>
                    )}
                    <StyledChartContainer>
                        <ConditionalRendering isTrue={isLoading}>
                            <Spinner message="Loading..." />
                        </ConditionalRendering>
                        <ConditionalRendering isTrue={!isLoading && chartData?.length > 0}>
                            <BarChart
                                data={chartData}
                                toUserChart={toUserChart}
                                hTitle={CHART_CONST_INFO.NUMBER_OF_TICKETS}
                                chartColors={chartColors}
                                selectedChart={selectedChart}
                                isDrillDownAllowed={isDrillDownAllowed}
                            />
                        </ConditionalRendering>
                        <ConditionalRendering isTrue={!isLoading && chartData?.length === 0}>
                            <FormattedMessage id="selfDesignation.search.results.noRecordsFound.title" />
                        </ConditionalRendering>
                    </StyledChartContainer>
                    <div className="--chart_legend">
                        <strong>{title}</strong>
                        <ul>
                            {serviceResponse?.[0]?.slice(1)?.map((item, index) => (
                                <li key={`${item}-${index}`}>
                                    <a
                                        data-tip
                                        ref={ref => (tStatusRef = ref)}
                                        data-for={`${item}-${index}_tooltip`}
                                        className="ds-u-font-size--small ds-text ds-u-measure--wide ds-u-color--muted ds-u-text-decoration--underline cursor--pointer"
                                        id={`${item}-${index}`}
                                    >
                                        <div
                                            className="--legend_button"
                                            id={`${item} ${index}`}
                                            style={{ background: `${defaultReportCoolers[index]}` }}
                                        />
                                        &nbsp;
                                        <a
                                            className={legendClassName[index]}
                                            href="#"
                                            id={index}
                                            onClick={e => filterBasedOnLegend(e, item)}
                                        >
                                            {item}
                                        </a>
                                        {item.toUpperCase() === 'OPEN' && (
                                            <ReactTooltip
                                                place="top"
                                                type="light"
                                                border={true}
                                                borderColor={'black'}
                                                effect="solid"
                                                role="tooltip"
                                                id={`${item}-${index}_tooltip`}
                                                clickable={true}
                                                delayHide={500}
                                                delayShow={500}
                                                delayUpdate={500}
                                                className="ds-u-text-transform--capitalize"
                                            >
                                                {'Unresolved and Untouched by Assignee'}
                                            </ReactTooltip>
                                        )}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BarChartContainer;
